import r2wc from "@r2wc/react-to-web-component";

import { persistReferralCodeFromUrl } from "@/shared/utils/referralCode";
import Navbar from "./Navbar";

persistReferralCodeFromUrl();

const NavbarWebComponent = r2wc(Navbar, {
  props: {
    hideMain: "boolean",
    hideHelp: "boolean",
    hideUser: "boolean",
  },
});

if (!customElements.get("navbar-web-component")) {
  customElements.define("navbar-web-component", NavbarWebComponent);
}
